import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';

const CardWrapper = styled.div`
  max-width: 251px;
  min-height: ${({ site }) => {
    if (site === '24MX') return '464px';
    if (site === 'ZPAR') return '380px';
    if (site === 'UBPE') return '420px';
    return '430px';
  }};
  background-color: ${select('white')};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: ${({ device }) => (device === 'mobile' ? '36px 10px 0px' : '36px 0px 0px')};
  position: relative;
  padding: 16px;
  gap: 24px;
`;

const HeaderCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  .title {
    width: 219px;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    white-space: break-spaces;
    height: 48px;
    color: ${({ titleColor }) => select(titleColor)};
  }
  .text-info {
    width: 189px;
    height: 20px;
    background-color: ${select('middleGray')};
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
    padding: 2px 12px;
  }
`;

const PriceWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  .price {
    font-size: 28px;
    font-weight: 700;
    font-stretch: normal;
    line-height: 28px;
    text-align: left;
  }
  span {
    font-size: 14px;
    font-weight: 400;
    position: relative;
    margin-top: 5px;
    margin-left: 9px;
    :before {
      content: '/';
      position: absolute;
      left: -9px;
    }
    :after {
      content: '*';
      position: absolute;
    }
  }
`;

const CheckInfo = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  font-size: 12px;
  overflow: hidden;
  .iva-info {
    color: ${select('midDarkGrayAux')};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
  }
  .text-item {
    width: 197px;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    white-space: break-spaces;
  }
`;

const RowCheck = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 8px;
`;

const CTA = styled.div`
  width: 219px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: ${select('white')};
  background: ${getColor('primary')};
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 130%;
  cursor: pointer;
  :hover {
    background-color: ${getColor('primaryHover')};
  }
`;

const Icon = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  background-image: url(${({ icon }) => icon});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin-top: ${({ mTop }) => mTop};
  margin-bottom: ${({ mBottom }) => mBottom};
`;

const Tag = styled.div`
  position: absolute;
  background-color: ${({ color }) => select(color)};
  color: ${select('white')};
  font-weight: 600;
  font-size: 12px;
  line-height: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  border-radius: 8px;
  left: calc(50% - 93px / 2 + 0.5px);
  top: -18px;
`;

export { CardWrapper, HeaderCard, PriceWrapper, CheckInfo, RowCheck, CTA, Icon, Tag };
